import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './Login.css';

const Login = () => {
  const { login } = useAuth();

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Warehouse Management System</h1>
        <p>Please sign in with your Google account to continue</p>
        <button className="login-button" onClick={login}>
          Sign in with Google
        </button>
      </div>
    </div>
  );
};

export default Login;
